<template>
    <div id="services">
        <h2>Services</h2>
        <ul>
            <li class="service-group" v-for="service in services" v-bind:key="service.idResourceService">
                <span class="service-title">{{service.title}}</span>
                <span class="service-description text-muted" v-show="service.description">{{service.description}}</span>
                <span class="service-note" v-show="service.note">{{service.note}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Services",
        props: ['services']
    }
</script>

<style scoped>

</style>